module.exports = __webpack_public_path__ + "img/4.46ab47ac.jpg";